import React, { useState } from 'react';
import { Card, Button } from './ui';
import { ShieldCheck, Plus, Minus, Scale, Clock, Lock, Zap, FileText } from 'lucide-react';
const CHECKOUT_URL = 'https://frezzer-lleno.impultienda.ar/checkout';
export function Guarantee() {
  return <section className="py-10 px-4" data-id="element-191" data-mp="31lkdd7y2nf2q">
      <div className="max-w-3xl mx-auto" data-id="element-192" data-mp="2wlfzzqsgn0gq">
        <Card className="bg-white border-emerald-500/40 text-center relative overflow-hidden" data-id="element-193" data-mp="2wmr1tl2chy57">
          <div className="absolute -right-10 -top-10 text-emerald-500/10" data-id="element-194" data-mp="3u7lr33vxjoy2">
            <ShieldCheck className="w-64 h-64" data-id="element-195" data-mp="3pamtgbd24zv4" />
          </div>
          <div className="relative z-10" data-id="element-196" data-mp="3ki24bn53jaxx">
            <ShieldCheck className="w-16 h-16 text-emerald-600 mx-auto mb-6" data-id="element-197" data-mp="3kh0u1kvwmsh9" />
            <h2 className="text-3xl font-bold text-navy mb-6" data-id="element-198" data-mp="3fih6jg1nx8ms">
              GARANTÍA DE 7 DÍAS
            </h2>
            <p className="text-xl text-ink-muted mb-6" data-id="element-199" data-mp="gua4r7ivoed8">
              Queremos que puedas conocer el material con tranquilidad.
            </p>
            <p className="text-lg text-ink-muted mb-8" data-id="element-200" data-mp="2hjbdx6x5ha7z">
              Accedé al Kit y explorá sus recursos.
              <br data-id="element-201" data-mp="2lkomhormnril" />
              Si dentro del período de garantía decidís que
              <br data-id="element-202" data-mp="2lmr7fudxaugg" />
              <strong className="text-navy" data-id="element-203" data-mp="27trspulyt49y">no es para vos</strong>, podés
              solicitar el reembolso
              <br data-id="element-204" data-mp="2cs31s34frar4" />
              según las condiciones de compra.
            </p>
            <p className="text-sm text-emerald-700 font-medium" data-id="element-205" data-mp="1xvltxlvgge9b">
              Pago único · 100% digital · Acceso inmediato.
            </p>
          </div>
        </Card>
      </div>
    </section>;
}
export function FAQ() {
  const faqs = [{
    q: '¿Tengo que leer los 3 tomos antes de empezar?',
    a: 'No. El Kit está organizado para que puedas avanzar progresivamente y consultar las secciones y herramientas que más necesitás.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Después de completar tu compra recibís acceso digital al Kit.'
  }, {
    q: '¿Es un producto físico?',
    a: 'No. El Kit de Conducta Infantil es 100% digital.'
  }, {
    q: '¿Puedo consultarlo desde el celular?',
    a: 'Sí. Podés acceder al material desde dispositivos compatibles y consultarlo cuando lo necesites.'
  }, {
    q: '¿Qué pasa si nuestro principal problema son las rabietas?',
    a: 'El Tomo 2 está enfocado especialmente en límites, rabietas y emociones y se complementa con las herramientas prácticas del Kit.'
  }, {
    q: '¿Y si lo que más nos cuesta son las rutinas?',
    a: 'El Tomo 3 trabaja específicamente rutinas y planificación de conducta y se complementa con el Pack de Rutinas Visuales.'
  }, {
    q: '¿Incluye herramientas prácticas?',
    a: 'Sí. Además de los 3 tomos recibís los 5 bonos incluidos.'
  }, {
    q: '¿Reemplaza el acompañamiento profesional?',
    a: 'No. Es un recurso educativo para madres, padres y cuidadores y no sustituye evaluación, diagnóstico o acompañamiento profesional cuando sea necesario.'
  }, {
    q: '¿Tiene garantía?',
    a: 'Sí. La compra cuenta con una garantía de 7 días según las condiciones indicadas.'
  }];
  const [open, setOpen] = useState<number | null>(0);
  return <section className="py-12 px-4 bg-cream-100 pt-[4px] pb-[4px]" data-id="element-206" data-mp="14k0exm6xxfqp">
      <div className="max-w-3xl mx-auto" data-id="element-207" data-mp="19kfqc87nwd61">
        <h2 className="text-2xl md:text-3xl font-bold text-navy text-center mb-8 flex items-center justify-center gap-3" data-id="element-208" data-mp="19lhd39y1io3l">
          <span className="text-teal-600" data-id="element-209" data-mp="1djnh4a7hupkt">❓</span> PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-210" data-mp="1iirr3328src7">
          {faqs.map((faq, i) => <div key={i} className="border border-cream-300 rounded-xl bg-white overflow-hidden" data-id="element-211" data-mp="1ncchoa1iaj1d" data-mpi={i}>
              <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpen(open === i ? null : i)} data-id="element-212" data-mp="1sc8iy1itjwd8">
                <span className="font-bold text-navy pr-8" data-id="element-213" data-mp="2yzyuh18z756c">{faq.q}</span>
                {open === i ? <Minus className="w-5 h-5 text-teal-600 shrink-0" data-id="element-214" data-mp="2u0vrrnggxb1j" /> : <Plus className="w-5 h-5 text-ink-soft shrink-0" data-id="element-215" data-mp="37s95gkrp3eon" />}
              </button>
              {open === i && <div className="px-6 pb-4 text-ink-muted" data-id="element-216" data-mp="33rqcuohza4le">{faq.a}</div>}
            </div>)}
        </div>
      </div>
    </section>;
}
export function CostOfInaction() {
  return <section className="py-12 px-4" data-id="element-217" data-mp="2b31gf2rvanfz">
      <div className="max-w-4xl mx-auto" data-id="element-218" data-mp="2b42rv8cspby8">
        <div className="text-center mb-8" data-id="element-219" data-mp="2p2170fyxxces">
          <h2 className="text-2xl md:text-3xl font-bold text-navy mb-4 flex items-center justify-center gap-3" data-id="element-220" data-mp="2p32kss7ccd07">
            <Scale className="w-9 h-9 text-amber-500" data-id="element-221" data-mp="2k510y523c9no" /> ¿CUÁNTO CUESTA SEGUIR
            IMPROVISANDO?
          </h2>
        </div>

        <div className="overflow-x-auto mb-10" data-id="element-222" data-mp="3vicyjy79bw1e">
          <table className="w-full text-left border-collapse bg-white rounded-xl overflow-hidden" data-id="element-223" data-mp="3vhle9jj41kqf">
            <thead data-id="element-224" data-mp="7s6bsdt05uki">
              <tr className="border-b border-cream-300 bg-cream-100" data-id="element-225" data-mp="7vu4jaqmicy6">
                <th className="p-4 text-navy font-medium" data-id="element-226" data-mp="bwmc7zjuk9sc">Sin un sistema</th>
                <th className="p-4 text-coral-600 font-bold" data-id="element-227" data-mp="3u1poc488dm29">Costo cotidiano</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-cream-300" data-id="element-228" data-mp="2uwmqz9izkx7">
              <tr data-id="element-229" data-mp="qjfn8smc2teq">
                <td className="p-4 text-ink-muted" data-id="element-230" data-mp="ql0h0g0tq8bj">
                  Repetir la misma instrucción una y otra vez
                </td>
                <td className="p-4 text-navy font-medium" data-id="element-231" data-mp="vl4x44xtl118">
                  Frustración para ambos
                </td>
              </tr>
              <tr data-id="element-232" data-mp="lspf57miwcgc">
                <td className="p-4 text-ink-muted" data-id="element-233" data-mp="ls7cnt99p1zz">
                  Improvisar frente a una rabieta
                </td>
                <td className="p-4 text-navy font-medium" data-id="element-234" data-mp="19h8lhhm0if5s">
                  No saber qué hacer cuando más necesitás claridad
                </td>
              </tr>
              <tr data-id="element-235" data-mp="1o5sa79ykj6m2">
                <td className="p-4 text-ink-muted" data-id="element-236" data-mp="1o47fnkc97no7">Rutinas sin estructura</td>
                <td className="p-4 text-navy font-medium" data-id="element-237" data-mp="1j65wz0iqpqd9">
                  Discusiones que vuelven a repetirse
                </td>
              </tr>
              <tr data-id="element-238" data-mp="1e9ffc8raempq">
                <td className="p-4 text-ink-muted" data-id="element-239" data-mp="1a5r51ib9td0s">Límites inconsistentes</td>
                <td className="p-4 text-navy font-medium" data-id="element-240" data-mp="1a7tvg3gc5861">
                  Menos claridad para todos
                </td>
              </tr>
              <tr data-id="element-241" data-mp="10fo5ez9n90th">
                <td className="p-4 text-ink-muted" data-id="element-242" data-mp="10f5ztc13da8w">Perder la paciencia</td>
                <td className="p-4 text-navy font-medium" data-id="element-243" data-mp="vgbk4iyf81t0">
                  Culpa después del conflicto
                </td>
              </tr>
              <tr data-id="element-244" data-mp="qjl5m029le9p">
                <td className="p-4 text-ink-muted" data-id="element-245" data-mp="qfx8kqxm29q8">
                  Cada adulto respondiendo de manera diferente
                </td>
                <td className="p-4 text-navy font-medium" data-id="element-246" data-mp="hgtpvo2cvwc9">
                  Menos consistencia
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="text-center max-w-2xl mx-auto mb-10" data-id="element-247" data-mp="2y39uzjhs1w64">
          <h3 className="text-2xl font-bold text-teal-600 mb-4" data-id="element-248" data-mp="2y5mlwm5ijgvb">
            Mañana van a volver a aparecer: “Guardá los juguetes.” “Apagá la
            tablet.” “Vamos a bañarnos.” “Es hora de dormir.” La diferencia es
            que podés llegar a esos momentos con nuevas herramientas.
          </h3>
          <blockquote className="text-xl text-ink-muted italic border-l-4 border-teal-500 pl-6 py-2 text-left" data-id="element-249" data-mp="2abuqbk2j32rp">
            "No se trata de tener hijos perfectos. Se trata de tener más
            claridad para saber cómo actuar cuando aparecen los momentos
            difíciles."
          </blockquote>
        </div>

        {/* Final CTA Block */}
        <Card glow className="bg-white border-brand-500/50 text-center" data-id="element-250" data-mp="1qqq52f5u46mk">
          <div className="inline-flex items-center gap-2 bg-red-500/10 text-red-600 border border-red-500/20 px-4 py-2 rounded-full font-bold mb-8" data-id="element-251" data-mp="1vorsfcaams3u">
            <Clock className="w-5 h-5" data-id="element-252" data-mp="p28ue7t4cau6" />
            EL PRECIO CIERRA EN: 23 hs : 59 min : 52 seg
          </div>

          <div className="grid md:grid-cols-1 gap-6 mb-8 max-w-md mx-auto" data-id="element-253" data-mp="k4qkof7a1rl4">
            <div className="p-6 border border-cream-300 rounded-xl bg-cream-100" data-id="element-254" data-mp="y36tcbop9s5w">
              <h4 className="font-bold text-navy mb-2" data-id="element-255" data-mp="tzqur9t2lhqk">
                🧩 KIT DE CONDUCTA INFANTIL
              </h4>
              <p className="text-sm text-ink-muted mb-4" data-id="element-256" data-mp="17z0ay9ha0buj">
                3 Tomos + 5 Bonos · Pago único
              </p>
              <div className="flex items-baseline justify-center gap-2 mb-6" data-id="element-257" data-mp="12zdxq01g6vlq">
                <span className="text-ink-soft line-through text-sm" data-id="element-258" data-mp="1hpv13oxn7vl9">
                  49.99
                </span>
                <span className="text-3xl font-black text-navy" data-id="element-259" data-mp="1cte9ulv5d13y">19.99</span>
                <span className="text-sm text-ink-muted" data-id="element-260" data-mp="1qrm2wip2bi9u">USD</span>
              </div>
              <Button className="w-full" variant="outline" onClick={() => {
              window.location.href = CHECKOUT_URL;
            }} data-id="element-261" data-mp="1lt150pxa9aok">
                → QUIERO MI KIT DE CONDUCTA INFANTIL
              </Button>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-ink-muted" data-id="element-262" data-mp="1wctnh5hn7zt4">
            <span className="flex items-center" data-id="element-263" data-mp="20d3sofxm2m6x">
              <Lock className="w-4 h-4 mr-1 text-ink-soft" data-id="element-264" data-mp="1mnjvdpmsuh50" /> Pago seguro
            </span>
            <span className="flex items-center" data-id="element-265" data-mp="1re07n6evvwps">
              <Zap className="w-4 h-4 mr-1 text-amber-500" data-id="element-266" data-mp="1res40jgb1yh4" /> Acceso inmediato
            </span>
            <span className="flex items-center" data-id="element-267" data-mp="1cqf6hi1kk7ki">
              <ShieldCheck className="w-4 h-4 mr-1 text-emerald-600" data-id="element-268" data-mp="1ho6yec27rtop" /> Garantía
              7 días
            </span>
            <span className="flex items-center" data-id="element-269" data-mp="13nw6d5p6491y">
              <FileText className="w-4 h-4 mr-1 text-teal-600" data-id="element-270" data-mp="13p7k9ycbux6s" /> 100% digital
            </span>
          </div>
        </Card>
      </div>
    </section>;
}
export function Footer() {
  return <footer className="bg-cream-100 py-10 px-4 border-t border-cream-300" data-id="element-271" data-mp="348gigyedv20l">
      <div className="max-w-4xl mx-auto text-center" data-id="element-272" data-mp="39a5rk8i1p5m1">
        <div className="inline-flex items-center gap-2 mb-6" data-id="element-273" data-mp="2v9bhzmj9gyls">
          <span className="text-2xl" data-id="element-274" data-mp="2vawehhp4yrma">🧩</span>
          <span className="text-teal-600 font-bold tracking-widest uppercase" data-id="element-275" data-mp="3084xfki3yzol">
            PUNTO DIGITAL™
          </span>
        </div>

        <p className="text-ink-muted mb-4 max-w-2xl mx-auto" data-id="element-276" data-mp="3nz21yc7kqupt">
          Herramientas prácticas para madres, padres y cuidadores que quieren
          entender mejor la conducta, acompañar emociones, establecer límites y
          construir rutinas con mayor claridad.
        </p>
        <p className="text-ink-soft mb-8 italic" data-id="element-277" data-mp="3j6h7d8gugdl8">
          Porque criar no viene con un manual... pero eso no significa que
          tengas que improvisar frente a cada momento difícil.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 text-sm text-ink-muted mb-12" data-id="element-278" data-mp="fifil7hendvw">
          <a href="mailto:supportpuntodigital@gmail.com" className="hover:text-teal-600 transition-colors" data-id="element-279" data-mp="ovoavaizgn3m">
            📧 supportpuntodigital@gmail.com
          </a>
          <a href="#" className="hover:text-teal-600 transition-colors" data-id="element-280" data-mp="ymamyurhqvhk">
            🌐 www.puntodigital.store
          </a>
        </div>

        <div className="text-xs text-ink-faint space-y-2" data-id="element-281" data-mp="5y51g5sm52go">
          <p data-id="element-282" data-mp="5yn69qtccp07">© Punto Digital™ 2026 — Todos los derechos reservados.</p>
          <p data-id="element-283" data-mp="1xbfhhyqdxqf">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>

        <div className="mt-12 pt-8 border-t border-cream-300" data-id="element-284" data-mp="fx43v6msc1v8">
          <p className="text-teal-600 font-medium italic" data-id="element-285" data-mp="awoqif2i6ud9">
            🧩 "Menos improvisación. Más herramientas para saber cómo actuar."
          </p>
        </div>
      </div>
    </footer>;
}